const countries = require('./countries.json')
const flatCountries = (function () {
  const flat = []

  countries.forEach(c => {
    if (!Array.isArray(c.mask)) {
      flat.push(c)
    } else {
      c.mask.forEach(cm => {
        flat.push({ ...c, mask: cm })
      })
    }
  })

  return flat
})()

const getOnlyDigits = (string) => {
  return string.replace(/#/g, '').replace(/\(/g, '').replace(/\)/g, '').replace(/\+/g, '').replace(/-/g, '')
}
const normalCodes = flatCountries.map(item => {
  const normal = { ...item }

  let digits = `${item.code}${item.mask}`.replace(/#/g, '').replace(/\(/g, '').replace(/\)/g, '').replace(/\+/g, '').replace(/-/g, '')
  normal.mask = item.code + item.mask
  normal.code = '+'

  while (digits.length > 0) {
    normal.code += digits[0]
    normal.mask = normal.mask.replace(digits[0], '#')
    digits = digits.slice(1)
  }

  return normal
})

const getMask = (country) => {
  return country.mask.replace(/[0-9]/g, '#').replace(/#/g, '0')
}

export const getAllMasks = () => {
  return normalCodes.map(c => {
    return {
      mask: getMask(c),
      startsWith: c.code.slice(1)
    }
  })
}

export const getDefaultMaskState = () => {
  return {
    mask: getAllMasks(),
    dispatch: function (appended, dynamicMasked) {
      const value = (dynamicMasked.value + appended).replace(/\D/g, '')

      const filtered = dynamicMasked.compiledMasks.filter(function (m) {
        return value.indexOf(m.startsWith) === 0 || m.startsWith.indexOf(value) === 0
      }).filter(m => {
        return m.mask.length - 2 >= dynamicMasked.value.length
      })
        .sort((a, b) => a.mask.length - b.mask.length)

      return filtered[0] || dynamicMasked.currentMask
    }
  }
}

const getUniq = (a) => {
  const uniq = []
  a.forEach((c) => {
    if (!uniq.find(unI => unI.code === c.code && unI.name === c.name)) {
      uniq.push(c)
    }
  })
  return uniq
}

export const _getCountries = (val) => {
  if (!val) return getUniq(normalCodes.map(item => ({ code: item.code, name: item.name })))
  return getUniq(normalCodes.filter(s => getOnlyDigits(s.code).indexOf(getOnlyDigits(val)) === 0))
}

export const getMaskByName = (name, code) => {
  const nCode = normalCodes.find(item => item.name === name && item.code === code)
  return {
    ...nCode,
    startsWith: nCode.code.slice(1),
    mask: getMask(nCode)
  }
}

export const getFavoriteMasks = () => {
  const favoriteNames = [
    'United Kingdom',
    'United States',
    'Germany',
    'Spain',
    'France'
  ]
  return normalCodes.filter(item => favoriteNames.indexOf(item.name) !== -1).map(item => (getMask(item)))
}

export const getCountries = (val) => {
  const countries = _getCountries(val)
  const favoriteNames = [
    'United Kingdom',
    'United States',
    'Germany',
    'Spain',
    'France'
  ]

  let sortFavorite = Array(5)
  const favorite = countries.filter(c => favoriteNames.indexOf(c.name) !== -1)

  favorite.forEach(c => {
    const index = favoriteNames.indexOf(c.name)
    sortFavorite[index] = c
  })

  sortFavorite = sortFavorite.filter(s => Boolean(s))

  const other = countries.filter(c => favoriteNames.indexOf(c.name) === -1)

  return [sortFavorite, [...sortFavorite.slice(3), ...other]]
}



// WEBPACK FOOTER //
// ./components/phone-input/model/index.js